@if (visible()) {
  @switch (loadState()) {
    @case ('loading') {
      <p class="run-dialog__runners-loading">
        <mat-progress-spinner mode="indeterminate" diameter="16" />
        {{ 'testCases.run.local.loading' | translate }}
      </p>
    }
    @case ('failed') {
      <div class="run-dialog__runners-error" role="alert">
        <mat-icon aria-hidden="true">error</mat-icon>
        <span>{{ 'testCases.run.local.loadFailed' | translate }}</span>
        <button
          mat-stroked-button
          type="button"
          class="run-dialog__retry"
          data-testid="run-runners-retry"
          (click)="loadRunners()"
        >
          {{ 'testCases.run.local.retry' | translate }}
        </button>
      </div>
    }
    @default {
      @if (runners().length > 0) {
        <label class="run-dialog__runner-label" for="run-dialog-runner">
          {{ labelKey() | translate }}
        </label>
        <select
          id="run-dialog-runner"
          class="run-dialog__runner-select"
          data-testid="run-runner-select"
          required
          (change)="onRunnerChange($event)"
        >
          <option value="" disabled [selected]="selectedValue() === null">
            {{ 'testCases.run.local.chooseRunner' | translate }}
          </option>
          <optgroup data-testid="run-runner-group" [label]="'testCases.run.local.groupRunners' | translate">
            @for (runner of runners(); track runner.id) {
              @if (!runner.online) {
                <option [value]="runner.id" disabled [selected]="runner.id === selectedRunnerId()">
                  {{
                    'testCases.run.local.offlineOption'
                      | translate: { name: runner.name, when: runner.lastSeenAt | date: 'short' }
                  }}
                </option>
              } @else if (cannotRecord(runner)) {
                <option [value]="runner.id" disabled [selected]="runner.id === selectedRunnerId()">
                  {{ cannotRecordOption() | translate: { name: runner.name } }}
                </option>
              } @else {
                <option [value]="runner.id" [selected]="runner.id === selectedRunnerId()">
                  {{ runner.name }}
                </option>
              }
            }
          </optgroup>
          @if (!recordingMode() && labelOptions().length > 0) {
            <optgroup data-testid="run-requirement-group" [label]="'testCases.run.local.groupRequirement' | translate">
              @for (label of labelOptions(); track label) {
                <option [value]="labelPrefix + label" [selected]="label === selectedLabel()">
                  {{ 'testCases.run.local.anyWithLabel' | translate: { label } }}
                </option>
              }
            </optgroup>
          }
        </select>
      } @else {
        <p class="run-dialog__runners-none">
          <mat-icon aria-hidden="true">info</mat-icon>
          {{ 'testCases.run.local.noRunner' | translate }}
        </p>
        @if (projectId(); as id) {
          <a class="run-dialog__connect" [routerLink]="['/projects', id, 'edit']" (click)="connect.emit()">
            <mat-icon aria-hidden="true">computer</mat-icon>
            {{ 'testCases.run.local.connectComputer' | translate }}
          </a>
        }
      }
    }
  }
}
